import { Checkbox, CheckboxProps } from '@mui/material';
import styled from 'styled-components';

export const StyledCheckbox = styled(Checkbox)`
  & svg {
    background-color: #fff;
  }
`;

export const AppCheckbox = (props: CheckboxProps) => {
  return <StyledCheckbox {...props} />;
};
